import z from 'zod';
import arrayEntry from './arrayEntry.js';
import internationalizedArrayDepartmentsValue from '../objects/internationalizedArrayDepartmentsValue.js';
var id = 'internationalizedArrayDepartments';
var fragment = {
    type: 'array',
    of: [
        {
            type: 'internationalizedArrayDepartmentsValue'
        }
    ]
};
var validator = z.array(internationalizedArrayDepartmentsValue.validator.merge(arrayEntry.validator));
export default {
    id: id,
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayDepartments.js.map